import React from 'react';

export function Cyprus(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="513" height="342" fill="white"/>
      <path d="M130,80 Q200,60 256,100 Q312,60 383,80 Q340,150 256,200 Q172,150 130,80Z" fill="#D57C39"/>
      <path d="M210,210 Q256,225 302,210 L302,230 Q256,245 210,230Z" fill="#4CAF50"/>
      <path d="M220,225 Q256,235 292,225 L292,240 Q256,250 220,240Z" fill="#4CAF50"/>
    </svg>
  );
}
